import { Button, Tooltip } from "@fluentui/react-components";
import {
  ArrowSyncCheckmarkRegular,
  LinkDismissRegular,
  LinkRegular,
  InfoRegular,
} from "@fluentui/react-icons";
import {
  Cell,
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
} from "@silevis/reactgrid";
import * as React from "react";

export interface InsurerReportEntryOptionsCell extends Cell {
  type: "insurerreportentryoptions";
  matched?: boolean;
  matchFn?: any;
  unmatchFn?: any;
  viewFn?: any;
  rowId?: any;
  selected?: boolean;
  highlighted?: boolean;
  t: any;
}

export class InsurerReportEntryOptionsCellTemplate
  implements CellTemplate<InsurerReportEntryOptionsCell>
{
  getCompatibleCell(
    uncertainCell: Uncertain<InsurerReportEntryOptionsCell>
  ): Compatible<InsurerReportEntryOptionsCell> {
    const t: any = getCellProperty(uncertainCell, "t", "function");

    let matched = false;
    try {
      matched = getCellProperty(uncertainCell, "matched", "boolean");
    } catch {
      matched = false;
    }

    let matchFn: any;
    try {
      matchFn = getCellProperty(uncertainCell, "matchFn", "function");
    } catch {
      matchFn = undefined;
    }
    let unmatchFn: any;
    try {
      unmatchFn = getCellProperty(uncertainCell, "unmatchFn", "function");
    } catch {
      unmatchFn = undefined;
    }
    let viewFn: any;
    try {
      viewFn = getCellProperty(uncertainCell, "viewFn", "function");
    } catch {
      viewFn = undefined;
    }

    let rowId: any;
    try {
      rowId = getCellProperty(uncertainCell, "rowId", "number");
    } catch {
      rowId = undefined;
    }

    let selected = false;
    try {
      selected = getCellProperty(uncertainCell, "selected", "boolean");
    } catch {
      selected = false;
    }
    let highlighted: boolean | undefined;
    try {
      highlighted = getCellProperty(uncertainCell, "highlighted", "boolean");
    } catch {
      highlighted = false;
    }

    return {
      ...uncertainCell,
      text: "",
      value: NaN,
      matched,
      matchFn,
      unmatchFn,
      viewFn,
      rowId,
      selected,
      highlighted,
      t,
    };
  }

  getClassName(
    cell: Compatible<InsurerReportEntryOptionsCell>,
    isInEditMode: boolean
  ): string {
    return (
      (cell.className ? cell.className : "") +
      (cell.selected ? " rg-selected" : "") +
      (cell.highlighted ? " highlighted-selected-row" : "")
    );
  }

  render(
    cell: Compatible<InsurerReportEntryOptionsCell>,
    isInEditMode: boolean,
    onCellChanged: (
      cell: Compatible<InsurerReportEntryOptionsCell>,
      commit: boolean
    ) => void
  ): React.ReactNode {
    return <OptionsCell cell={cell} />;
  }
}

interface DIProps {
  cell: Record<string, any>;
}

const OptionsCell: React.FC<DIProps> = ({ cell }) => {
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      {cell.matched ? (
        <>
          <Tooltip
            content={cell.t("pct.viewMatchedTarget.label")}
            relationship="label"
          >
            <Button
              data-help="insurer-reports-entry-view"
              appearance="subtle"
              size="small"
              icon={<InfoRegular />}
              onClick={() => cell.viewFn(cell.rowId)}
            ></Button>
          </Tooltip>
          <Tooltip
            content={cell.t("pct.rematchInsurerReportEntry.label")}
            relationship="label"
          >
            <Button
              data-help="insurer-reports-entry-rematch"
              appearance="subtle"
              size="small"
              icon={<ArrowSyncCheckmarkRegular />}
              onClick={() => cell.matchFn(cell.rowId)}
            ></Button>
          </Tooltip>
          <Tooltip
            content={cell.t("pct.unmatchInsurerReportEntry.label")}
            relationship="label"
          >
            <Button
              data-help="insurer-reports-entry-unmatch"
              appearance="subtle"
              size="small"
              icon={<LinkDismissRegular />}
              onClick={() => cell.unmatchFn(cell.rowId)}
            ></Button>
          </Tooltip>
        </>
      ) : (
        <Tooltip
          content={cell.t("pct.matchInsurerReportEntry.label")}
          relationship="label"
        >
          <Button
            data-help="insurer-reports-entry-match"
            appearance="subtle"
            size="small"
            icon={<LinkRegular />}
            onClick={() => cell.matchFn(cell.rowId)}
          ></Button>
        </Tooltip>
      )}
    </div>
  );
};
